import { render, staticRenderFns } from "./CreateFarmForm.vue?vue&type=template&id=e8f3c88a&"
import script from "./CreateFarmForm.vue?vue&type=script&lang=ts&"
export * from "./CreateFarmForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports